<div class="checkbox" [style.display]="data!.hidden ? 'none' : 'block'" [className]="data.customClass">
    <mat-checkbox color="primary" [ngModel]="data!.value" [disabled]="data!.disabled" (ngModelChange)="onModelChange($event)">{{ data!.label }}</mat-checkbox>
</div>
